import { Swiper } from 'swiper';
import { Navigation } from 'swiper/modules';

class BlockHighlightNews {
  constructor() {
    this._init();
  }

  _init() {
    new Swiper('.highlight-news__swiper', {
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 20,
      grabCursor: true,
      autoHeight: false,
      // loop: true,
      navigation: {
        enabled: true,
        nextEl: '.swiper-button--next',
        prevEl: '.swiper-button--prev',
        disabledClass: 'swiper-button--disabled',
        hiddenClass: 'swiper-button--hidden',
        lockClass: 'swiper-button--lock'
      },
      preventInteractionOnTransition: true,
      modules: [Navigation]
    });
  }
}

export const blockHighlightNews = new BlockHighlightNews();
